import { IGetState, TBoardId, TFilterId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { setSortedSavedFilterIds } from './setSortedSavedFilterIds';
import { getSortedSavedFiltersIds } from '../selectors/getSortedSavedFiltersIds';

export const reorderSortedSavedFilterIds = (
    boardId: TBoardId,
    filterId: TFilterId,
    index: number,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        let result: TFilterId[];
        result = getSortedSavedFiltersIds(state, boardId);
        const idx = result.indexOf(filterId);
        if (idx > -1) result.splice(idx, 1);
        result.splice(index, 0, filterId);
        dispatch(setSortedSavedFilterIds(boardId, result));
    };
    return action;
};
